import { loginFacebook, loginGoogle } from 'actions/auth';

export default store => ({
	path: 'signup',
	indexRoute: {
		getComponent: (nextState, cb) =>
			require.ensure(
				[],
				require => {
					const component = require('./Home').default;
					cb(null, component);
				},
				'signup',
			),
	},
	childRoutes: [
		{
			path: 'result',
			indexRoute: {
				getComponent: (nextState, cb) =>
					require.ensure(
						[],
						require => {
							const component = require('./Result').default;
							cb(null, component);
						},
						'result',
					),
				onEnter: ({ location: { query: { token = '', service = '', referral = '' } } }) => {
					if (service === 'facebook') {
						store.dispatch(loginFacebook(token, referral));
					} else if (service === 'google') {
						store.dispatch(loginGoogle(token, referral));
					}
				},
			},
		},
	],
});



// WEBPACK FOOTER //
// ./src/routes/Signup/index.js